<template>
    <div class="mt-4">
        <prospect :items="items" />
    </div>
</template>

<script>
import Prospect from "./Prospect.vue";

export default {
    components: {
        Prospect,
    },
    data() {
        return {
            items: {
                name: "Prospect Today",
                prospect_type: "today",
            },
        };
    },
};
</script>
